import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=2899f547&scoped=true&"
import script from "./ProfileIcon.vue?vue&type=script&lang=js&"
export * from "./ProfileIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=2899f547&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2899f547",
  null
  
)

export default component.exports